export default {
  PageList: () => import('@/views/page/listPage/PageList'),
}